var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sb_top-bar"},[_c('div',{staticClass:"sb_top-bar_inner"},[_vm._m(0),_c('div',{staticClass:"sb_top-bar_logo"},[_c('Logo')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sb_top-bar_heading"},[_c('h1',[_c('b',[_vm._v("AI")]),_vm._v(" Architect Inspiration")])])
}]

export { render, staticRenderFns }